import permissions from 'constants/permissions'

const INCIDENT_LIST = [
  {
    name: 'Gerenciar',
    tag: permissions.INCIDENTS.LIST,
  },
]

export default INCIDENT_LIST
